export const stripMarketShare = value => {
    if (typeof value !== 'string') {
        return value;
    }

    return value.replace(/\s*-\s*[\d.,]+\s*%\s*$/, '').trim();
};

export default stripMarketShare;



// WEBPACK FOOTER //
// ./src/scripts/core/tools/brand.js